<template>
  <div class="cf-node-properties__input">
    <select 
      v-model="selectValue"
      class="form-control"
      :class="{'invalid': error}" 
      :required="required"
    >
      <option 
        v-for="(option, index) in options" 
        :key="index"
        :value="option.value"
      >
        {{ option.name }}
      </option>
    </select>
    <div
      v-if="errorMessage" 
      class="cf-node-properties__input-error"
    >
      {{ errorMessage }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'InputSelect',
  props: {
    value: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: ''
    },
    options: {
      type: Array,
      default() {
        return [];
      }
    },
    required: {
      type: Boolean,
      default: false,
    },
    error: {
      type: Object,
      default() {
        return null;
      }
    }
  },
  computed: {
    selectValue: {
      get() { 
        return this.value || this.placeholder;
      },
      set(selectValue) {
        this.$emit('input', selectValue);
      }
    },
    errorMessage() {
      return this.error?.errorMessage;
    }
  }
};
</script>